import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationToast from './NotificationToast';

const NotificationToasts = () => {
  const { toastNotifications, removeToastNotification, markToastAsRead } = useNotifications();

  if (toastNotifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-toasts-container">
      {toastNotifications.map((notification) => (
        <NotificationToast
          key={notification.id}
          notification={notification}
          onClose={() => removeToastNotification(notification.id)}
          onMarkAsRead={() => markToastAsRead(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationToasts;
